<template>
  <div id="app" :class="$store.state.device">
    <div class="wrap" v-if="ready">
      <transition name>
        <router-view />
      </transition>
    </div>
    <Footer v-if="ready" />
    <Confirm />
  </div>
</template>

<script type="text/javascript">
import Footer from "@/components/Footer.vue";
import Confirm from "@/components/Confirm.vue";
import { appService } from "@/services/app.service";
import { tap } from "rxjs/operators";
export default {
  data: () => {
    return {
      ready: false,
    };
  },
  components: {
    Footer,
    Confirm,
  },
  methods: {
    setDevice() {
      let w = window.innerWidth,
        device;
      if (w > 750) {
        device = "pc";
      } else {
        device = "mob";
      }
      // alert(device)
      this.$store.commit("setDevice", device);
    },
    checkDevice() {
      let ua = navigator.userAgent.toLowerCase();
      // console.log(ua);

      // if(ua.indexOf('ipad') > -1){
      //     document.querySelector('meta[name=viewport]').content = 'width=device-width,initial-scale=1,maximum-scale=1';
      // }else{
      //     document.querySelector('meta[name=viewport]').content = 'width=750,user-scalable=no,target-densitydpi=375';
      // }
      if (
        ua.indexOf("iphone") > -1 ||
        ua.indexOf("android") > -1 ||
        ua.indexOf("ipod") > -1
      ) {
        document.querySelector("meta[name=viewport]").content =
          "width=750,user-scalable=no,target-densitydpi=375";
      } else {
        document.querySelector("meta[name=viewport]").content =
          "width=device-width,initial-scale=1,maximum-scale=1";
      }
    },
  },
  created() {
    this.checkDevice();
    this.setDevice();
    // setInterval(()=>{
    //     this.checkDevice();
    //     this.setDevice();
    // },1e3);
    window.addEventListener(
      "resize",
      () => {
        this.checkDevice();
        // this.setDevice();
      },
      true
    );
    setTimeout(() => {
      this.checkDevice();
      this.setDevice();
    }, 200);
  },
  mounted() {
    appService.overall$
      .pipe(
        tap((res) => {
          this.ready = res;
        })
      )
      .subscribe();

    let list = [
      "about-b-slide.jpg",
      "about-m-slide-13.jpg",
      "about-m-slide-22.jpg",
      "about-m-slide-8.jpg",
      "icon-plus.png",
      "index-shop.jpg",
      "member-icon4.png",
      "pIndex-ins.png",
      "pMember-banner.jpg",
      "shop-bottom.png",
      "about-b-slide1.jpg",
      "about-m-slide-14.jpg",
      "about-m-slide-23.jpg",
      "about-m-slide-9.jpg",
      "index-b-slide1.jpg",
      "menu-white.png",
      "pIndex-m-slide1.jpg",
      "pIndex-m-slide2.jpg",
      "pIndex-m-slide3.jpg",
      "pProject-banner.jpg",
      "shop-map.jpg",
      "about-b-slide2.jpg",
      "about-m-slide-15.jpg",
      "about-m-slide-24.jpg",
      "about-m-slide.jpg",
      "index-b-slide2.jpg",
      "logo-s.png",
      "menu.png",
      "pIndex-next.png",
      "pShop-banner.jpg",
      "shop-map1.jpg",
      "about-b-slide3.jpg",
      "about-m-slide-16.jpg",
      "about-m-slide-25.jpg",
      "about-photo1.jpg",
      "index-b-slide3.jpg",
      "logo-w.png",
      "pAbout-banner.jpg",
      "pIndex-prev.png",
      "shop-map2.jpg",
      "about-b-slide4.jpg",
      "about-m-slide-17.jpg",
      "about-m-slide-26.jpg",
      "about-photo2.jpg",
      "index-banner1.jpg",
      "logo.png",
      "pIndex-about1.jpg",
      "pIndex-shop.jpg",
      "shop-map3.jpg",
      "about-banner.jpg",
      "about-m-slide-18.jpg",
      "about-m-slide-3.jpg",
      "close.png",
      "index-m-slide1.jpg",
      "index-m-slide2.jpg",
      "index-m-slide3.jpg",
      "map-icon.png",
      "pIndex-about2.jpg",
      "pIndex-t-slide1.jpg",
      "index-t-slide1.png",
      "index-t-slide2.png",
      "index-t-slide3.png",
      "shop-photo1.jpg",
      "about-m-slide-1.jpg",
      "about-m-slide-19.jpg",
      "about-m-slide-4.jpg",
      "dialog-ins.png",
      "index-share-ins.png",
      "member-banner.jpg",
      "pIndex-about3.jpg",
      "pIndex-t-slide2.jpg",
      "shop-photo2.jpg",
      "about-m-slide-10.jpg",
      "about-m-slide-2.jpg",
      "about-m-slide-5.jpg",
      "dialog-wx.png",
      "index-share-wechat.png",
      "member-icon1.png",
      "pIndex-dialog-ins.png",
      "pIndex-t-slide3.jpg",
      "shop-photo3.jpg",
      "about-m-slide-11.jpg",
      "about-m-slide-20.jpg",
      "about-m-slide-6.jpg",
      "icon-gt.png",
      "index-shareIns.png",
      "member-icon2.png",
      "pIndex-dialog-wx.png",
      "pIndex-wx-h.png",
      "project-banner.jpg",
      "shop-top.png",
      "about-m-slide-12.jpg",
      "about-m-slide-21.jpg",
      "about-m-slide-7.jpg",
      "icon-minus.png",
      "index-shareWx.png",
      "member-icon3.png",
      "pIndex-ins-h.png",
      "pIndex-wx.png",
      "pd-img1.png",
      "pd-img2.png",
      "pd-img3.png",
      "pd-img4.png",
      "pd-img5.png",
      "pd-img6.png",
      "pd-img7.png",
      "pd-img8.png",
      "pd-img9.png",
      "pd-img10.png",
      "pd-img11.png",
      "pd-img12.png",
      "pd-img13.png",
      "pd-img15.png",
      "pd-img16.png",
      "pd-img17.png",
      "pd-img18.png",
      "pd-img-body1.png",
      "pd-img-body2.png",
      "pd-img-body3.png",
      "pd-img-body4.png",
      "pd-img-body5.png",
      "pd-img-body6.png",
      "pd-img-body7.png",
      "pd-img-body8.png",
      "pd-img-body9.png",
      "pd-img-head1.png",
      "pd-img-head2.png",
      "pd-img-head3.png",
      "pd-img-head4.png",
      "pd-img-head5.png",
      "pd-img-head6.png",
      "pd-img-head7.png",
      "pd-img-head8.png",
      "pd-img-head9.png",
      "pd-img-head10.png",
      "pd-img-head11.png",
      "shop-banner.jpg",
      "toTop.png",
    ];
    list.forEach((n) => {
      require(`./assets/${n}`);
    });
  },
};
</script>

<style lang="scss">
html,
body {
  margin: 0;
  height: 100vh;
  overflow: auto;
  font-family: -apple-system, BlinkMacSystemFont, "PingFang SC",
    "Helvetica Neue", STHeiti, Tahoma, sans-serif;
  background: #fff !important;
  -webkit-overflow-scrolling: touch;
}
* {
  box-sizing: border-box;
}
#app {
  position: relative;
  height: 100vh;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  // > div {
  //     position: relative;
  //     height: 100vh;
  //     overflow: auto;
  //     -webkit-overflow-scrolling: touch;
  // }
}
.wrap {
  position: relative;
  margin: 0 auto;
  width: 100%;
  // @media (min-width: 750px) and (max-width: 1020px){
  //     width: 750px;
  // }
}

.disable {
  pointer-events: none;
}

.hidden {
  display: none !important;
}

.clearfix:after {
  visibility: hidden;
  display: block;
  font-size: 0;
  content: " ";
  clear: both;
  height: 0;
}

.clearfix {
  *zoom: 1;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}

body a {
  // background: rgba(13,32,187,.1);
  color: inherit;
  text-decoration: none;
  -webkit-tap-highlight-color: transparent;
}

div,
ul,
ol,
li,
p,
input,
h2,
h3,
span,
a,
strong,
b {
  margin: 0;
  padding: 0;
  font-weight: 300;
  list-style: none;
  -webkit-text-size-adjust: none;
}

::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #000;
}

.untouch {
  touch-callout: none;
  user-select: none;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
}
.flexBox {
  display: flex;
  flex-direction: column;
  justify-content: center;

  &.horizontal {
    flex-direction: row;
    justify-content: space-between;
  }
}

.screenBox {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100vh;
}

.mainGray {
  background: #f8f9f8;
}

.blockTit {
  margin-bottom: 48px;
  // font-weight: 200;
  font-size: 40px;
  line-height: 1;
  color: #333;
  text-align: center;
}
.blockText {
  margin: 0 auto;
  // font-weight: 200;
  font-size: 24px;
  line-height: 48px;
  color: #555;
  text-align: center;
}
.blockLink {
  display: block;
  margin: 14px auto 0;
  font-size: 26px;
  line-height: 40px;
  color: #ae9963 !important;
}
.blockBtn {
  display: block;
  margin: 75px auto 0;
  width: 450px;
  height: 90px;
  font-size: 28px;
  line-height: 90px;
  color: rgba(45, 45, 45, 1);
  text-align: center;
  background: #d6caab;
}
.pageTitle {
  position: absolute;
  left: 0;
  top: 150px;
  width: 100%;
  font-size: 46px;
  color: #fff;
  text-align: center;

  @media (max-width: 750px) {
    top: 180px;
    font-size: 38px;
  }
}

.mob {
  .mid-pagination,
  .bottom-pagination {
    span {
      margin-left: 16px !important;
      margin-right: 16px !important;
      width: 14px !important;
      height: 14px !important;
    }
  }
}
.pc {
  .mid-pagination,
  .bottom-pagination {
    span {
      // margin-left: 16px!important;
      // margin-right: 16px!important;
      width: 10px !important;
      height: 10px !important;
    }
  }
  // .hidden-pc {
  //     display: none;
  // }
}
.visiable-detail {
  display: none;
}

img:not(.logo) {
  pointer-events: none;
  user-select: none;
}

.c333 {
  color: #333 !important;
}

.table {
  .mu-dialog {
    max-width: none;
  }
  .mu-dialog-body {
    position: relative;
    padding: 50px 24px 30px;
    // padding: 50px 0 50px;
    // height: 516px;
  }
  .close {
    position: absolute;
    right: 0;
    top: 0;
    width: 50px;
    height: 50px;
    cursor: pointer;
    &::after,
    &::before {
      content: "";
      position: absolute;
      left: 15px;
      top: 50%;
      margin-top: -1px;
      width: 20px;
      height: 2px;
      background: #000;
      transform: rotate(45deg);
    }
    &::before {
      transform: rotate(-45deg);
    }
  }
  .mu-table-header-wrapper {
    background: #f8f9f8;
  }
  .mu-table th,
  .mu-table td {
    font-weight: 400;
    font-size: 16px;
    color: #313131;
  }
  .imgBox {
    max-height: 80vh;
    overflow: auto;
    > img {
      display: block;
      width: 100%;
    }
  }
}
.mTable {
  .mu-dialog {
    max-width: none;
    height: 100%;
  }
  .mu-dialog-body {
    position: relative;
    padding: 50px 0 0;
    height: 100%;
  }
  .close {
    position: absolute;
    right: 0;
    top: 0;
    width: 80px;
    height: 80px;
    cursor: pointer;
    &::after,
    &::before {
      content: "";
      position: absolute;
      left: 20px;
      top: 50%;
      margin-top: -1px;
      width: 40px;
      height: 2px;
      background: #000;
      transform: rotate(45deg);
    }
    &::before {
      transform: rotate(-45deg);
    }
  }
  .mu-table-header-wrapper {
    background: #f8f9f8;
  }
  .mu-table th {
    height: 96px;
    font-size: 24px;
  }
  .mu-table td {
    height: 94px;
    font-size: 24px;
    line-height: 1.5em;
  }

  .mBody {
    margin: 0 auto;
    width: 636px;
    height: 100%;
    overflow: auto;
  }

  &__title {
    position: relative;
    padding-left: 132px;
    height: 96px;
    font-weight: 500;
    font-size: 24px;
    line-height: 96px;
    color: rgba(45, 45, 45, 1);
    background: 40px center/60px 60px no-repeat rgba(214, 202, 171, 1);

    .icon {
      position: absolute;
      right: 40px;
      transform: rotate(180deg) scale(2, 0.9);
      transition: all 0.3s;
    }
  }
  &__detail {
    display: none;
    li {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 40px;
      height: 94px;
      font-weight: 500;
      font-size: 24px;
      line-height: 94px;
      color: rgba(49, 49, 49, 1);

      * {
        font-weight: inherit;
      }

      .priceIcon {
        float: left;
        width: 60px;
        height: 93px;
        background: left/46px 28px no-repeat;
        &.level1 {
          background-image: url(assets/priceIcon1.png);
        }
        &.level2 {
          background-image: url(assets/priceIcon2.png);
        }
        &.level3 {
          background-image: url(assets/priceIcon3.png);
        }
      }
    }
    li + li {
      border-top: 1px solid rgba(230, 230, 230, 1);
    }
  }
  .active {
    .mTable__title {
      .icon {
        transform: rotate(360deg) scale(2, 0.9);
      }
    }
    .mTable__detail {
      display: block;
    }
  }

  .imgBox {
    > img {
      display: block;
      width: 100%;
    }
  }
}
</style>
